export const ROLE_PRE_AUTH_USER = 'ROLE_PRE_AUTH_USER';
export const ROLE_PRE_AUTH_USER_NO_FACTOR = 'ROLE_PRE_AUTH_USER_NO_FACTOR';
export const ROLE_STORMPATH_USER = 'ROLE_STORMPATH_USER';
export const ROLE_ADMIN_USER = 'ROLE_ADMIN_USER';
export const ROLE_READ_USER = 'ROLE_READ_USER';
export const ROLE_FEATURE_USER = 'ROLE_FEATURE_USER';
export const ROLE_PRE_AUTH_ONBOARD_NO_FACTOR =
  'ROLE_PRE_AUTH_ONBOARD_NO_FACTOR';
